import React, { useEffect, useState } from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import {
  ATLDoubleButton,
  ATLNavigationButton,
  ATLSpacing,
  ATLTextBody,
  ATLTextHead,
  SpacingSizesEnum,
  TextAlignmentEnum,
  ATLButton,
  ButtonTypeEnum,
} from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../atlTheme'
import { SafeAreaView, ScrollView } from 'react-native'
import { openWhatsApp } from '../../utils/openWhatsApp'
import { BRIO_SAC_WHATSAPP_NUMBER, WHATSAPP_WEB_URL } from '../../constants/whatsAppInfo'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { ItemContainer, TopContainer } from './Components'
import { platformConfig } from '../../constants/platform'
import { usePromise } from '../../utils/hooks/usePromise'
import { getFaqs } from '../../services/main/getFaqs'
import { getFaqCategories } from './faqFormatters'
import { useGlobal } from '../../global/useGlobal'
import { Loading } from '../../components/loading/Loading'
import { EMAIL_SAC_BRIO, FORM_ASSISTANCE_TECHNICAL } from '../../constants/linksExternal'
import { openUrl } from '../../utils/openUrl'

export const AssistanceScreen: NavigationStackScreenComponent = () => {
  const [faqs] = useGlobal('faqs')
  const [categories, setCategories] = useState<string[]>()

  const openEmail = async () => {
    return await openUrl(EMAIL_SAC_BRIO)
  }

  const openAssistanceScreen = async () => {
    return await openUrl(FORM_ASSISTANCE_TECHNICAL)
  }

  const appRedirectToWhatsApp = () => {
    openWhatsApp('', BRIO_SAC_WHATSAPP_NUMBER)
  }

  const webRedirectToWhatsApp = () => {
    open(WHATSAPP_WEB_URL)
  }

  const redirectToWhatsApp = platformConfig.isWeb() ? webRedirectToWhatsApp : appRedirectToWhatsApp

  const { request: fetchFaqs, loading: isFetchingFaqs } = usePromise(getFaqs)

  useEffect(() => {
    fetchFaqs()
  }, [])

  useEffect(() => {
    setCategories(getFaqCategories(faqs))
  }, [faqs])

  return (
    <SafeAreaView>
      <ScrollView>
        <TopContainer>
          <ATLTextHead textAlignment={TextAlignmentEnum.left}>
            {formatMessage(messages.assistance_technical_assistance_title)}
          </ATLTextHead>
          <ATLTextBody labelBaseProps={{ multilineLimit: 4 }}>
            {formatMessage(messages.assistance_technical_assistance_subtitle)}
          </ATLTextBody>
          <ATLButton
            type={ButtonTypeEnum.default}
            title={formatMessage(messages.assistance_technical_assistance_button)}
            buttonBaseProps={{
              borderRadius: atlTheme.BorderRadius100,
            }}
            onPress={openAssistanceScreen}
          />
          <ATLSpacing type={SpacingSizesEnum.base} />
        </TopContainer>
        <TopContainer>
          <ATLTextHead textAlignment={TextAlignmentEnum.left}>
            {formatMessage(messages.assistance_frequentAskedQuestions_title)}
          </ATLTextHead>
          <ATLTextBody labelBaseProps={{ multilineLimit: 4 }}>
            {formatMessage(messages.assistance_frequentAskedQuestions_subtitle)}
          </ATLTextBody>
          <ATLSpacing type={SpacingSizesEnum.base} />
        </TopContainer>

        <>
          {isFetchingFaqs ? (
            <>
              <ATLSpacing type={SpacingSizesEnum.marginal} />
              <Loading />
            </>
          ) : (
            <>
              {categories?.map((category, index) => {
                return (
                  <ItemContainer key={index}>
                    <ATLNavigationButton
                      text={category}
                      onPressCell={() => Coordinator.goToQuestions(category)}
                      rightIconBaseProps={{
                        tintColor: atlTheme.ColorBrand1Default,
                      }}
                      labelBaseProps={{
                        textColor: atlTheme.ColorHighContrast,
                        fontWeight: atlTheme.FontWeight500,
                      }}
                    />
                  </ItemContainer>
                )
              })}
            </>
          )}
        </>

        <ItemContainer>
          <ATLTextHead textAlignment={TextAlignmentEnum.left}>
            {formatMessage(messages.assistance_contactUsTitle)}
          </ATLTextHead>
          <ATLTextBody labelBaseProps={{ multilineLimit: 2 }}>
            {formatMessage(messages.assistance_contactUs_phone)}
          </ATLTextBody>
          <ATLTextBody labelBaseProps={{ multilineLimit: 2 }}>
            {formatMessage(messages.assistance_contactUs_businessHoursTitle)}
          </ATLTextBody>
          <ATLTextBody labelBaseProps={{ multilineLimit: 3 }}>
            {formatMessage(messages.assistance_contactUs_businessHours)}
          </ATLTextBody>
          <ATLTextBody labelBaseProps={{ multilineLimit: 2 }}>
            {formatMessage(messages.assistance_contactUs_disclaimer)}
          </ATLTextBody>
          <ATLDoubleButton
            leftTitle={formatMessage(messages.assistance_actionButton_email)}
            leftOnPress={openEmail}
            rightTitle={formatMessage(messages.assistance_actionButton_whatsapp)}
            rightOnPress={redirectToWhatsApp}
            leftButtonProps={{
              borderRadius: atlTheme.BorderRadius100,
            }}
            rightButtonProps={{
              borderRadius: atlTheme.BorderRadius100,
            }}
          />
          <ATLSpacing type={SpacingSizesEnum.marginal} />
        </ItemContainer>
      </ScrollView>
    </SafeAreaView>
  )
}

AssistanceScreen.navigationOptions = CustomHeader(formatMessage(messages.assistance_appHeaderTitle), true, () =>
  Coordinator.goBack()
)
